import moduleConfig from "./items.config";

export default [
  {
    path: moduleConfig.basePath,
    component: () => import("./items.module"),
    children: [],
  },
];
